// extracted by mini-css-extract-plugin
export default {"arrow":"_1pfI5___BrandedAssets-module__arrow"};